import { render, staticRenderFns } from "./login-page.component.vue?vue&type=template&id=4c584a14"
import script from "./login-page.component.ts?vue&type=script&lang=ts&external"
export * from "./login-page.component.ts?vue&type=script&lang=ts&external"
import style0 from "./login-page.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports